<!------------------------------------------------------------------------------
 File: BaseDatePicker
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-11
 Time: 11:41
 Reference: Plugin http://amsul.github.io/pickadate.js/
 Note: uses resources/assets/vendor/picksdate.js/lib/picker.date.js
------------------------------------------------------------------------------->
<template>
    <div class="md-form"
         v-tooltips-enabled="{
                        active:tooltip,
                        title:title
                    }">
        <i class="prefix material-icons">date_range</i>

        <date-picker-component
                :tabindex="tabindex"
                :id="id"
                :name="field"
                :set_active="set_active"
                :set_date="set_date"
                :set_now="set_now"
                @dateSet="dateSet"></date-picker-component>

        <label :for="id">{{label}}</label>
    </div>
</template>

<script>
	import {uniqueId} from '../../helpers/classesAndIds';

	window.Vue.component('date-picker-component', require('./BaseDatePickerComponent'));

	export default {
		name: "BaseDatePicker",
		components: {},
		props: {
			id: {
				type: String,
				default: uniqueId('date_picker')
			},
			label: {
				type: String,
				default: 'Date'
			},
			field: {
				type: String,
				default: 'date_field'
			},
			set_active: {
				type: Boolean,
				default: true
			},
			set_value: {
				type: String,
                default:null
			},
			set_date: {
				type: String
			},
			set_now: {
				type: Boolean,
				default: true
			},
			title:{
				type:String
			},
			tooltip: {
				type: Boolean,
				default: true
			},
			tabindex: {
				type: Number,
				default: 0
			}
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
		},
		data() {
		    return {}
		},
		methods: {
			dateSet(dateObject) {
				this.$emit('input_value', dateObject);
			},
		},
		watch: {
		},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseDatePicker.vue?1b000f2a